"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tools_1 = require("./tools");
var smartScroll = function (container, selectorScrollable) {
    var that = this;
    if (that) {
        that.container = container;
        that.selectorScrollable = selectorScrollable;
        // css追加
        tools_1.loadCssCode(that.styleHtml);
        that._init();
    }
};
smartScroll.prototype = {
    htmlDom: typeof document != 'undefined' ? document.querySelector('html') : '',
    _init: function () {
        var that = this;
        if (!(that.container instanceof HTMLElement)) {
            that.container =
                typeof document != 'undefined'
                    ? document.querySelector(that.container)
                    : '';
        }
        if (!that.selectorScrollable ||
            that.container.getAttribute('isBindScroll')) {
            // 如果没有滚动容器选择器，或者已经绑定了滚动时间，忽略
            return;
        }
        that.selectorScrollable =
            typeof that.selectorScrollable == 'string'
                ? [that.selectorScrollable]
                : that.selectorScrollable;
        that._bindFun();
        that.data = {
            posY: 0,
            maxscroll: 0,
        };
    },
    _bindFun: function () {
        var that = this;
        // 事件处理
        tools_1.addHandler(that.container, 'touchstart', function (event) {
            var events = event.touches[0] || event;
            // 先求得是不是滚动元素或者滚动元素的子元素
            var elTarget = event.target;
            if (elTarget === null) {
                return;
            }
            var elScroll = null;
            // 获取标记的滚动元素，自身或子元素皆可
            that.selectorScrollable.map(function (item) {
                if (elTarget.id == item) {
                    elScroll = elTarget;
                    return;
                }
                else if (tools_1.getParentIdTag(elTarget, item)) {
                    elScroll = tools_1.getParentIdTag(elTarget, item);
                    return;
                }
            });
            if (!elScroll) {
                return;
            }
            // 当前滚动元素标记
            that.data.elScroll = elScroll;
            // 垂直位置标记
            that.data.posY = events.pageY;
            that.data.scrollY = elScroll.scrollTop;
            // 是否可以滚动
            that.data.maxscroll = elScroll.scrollHeight - elScroll.clientHeight;
        });
        tools_1.addHandler(that.container, 'touchmove', function (event) {
            // 如果不足于滚动，则禁止触发整个窗体元素的滚动
            if (that.data.maxscroll <= 0) {
                // 禁止滚动
                event.preventDefault();
                return;
            }
            // 滚动元素
            var elScroll = that.data.elScroll;
            // 当前的滚动高度
            var scrollTop = elScroll.scrollTop;
            // 现在移动的垂直位置，用来判断是往上移动还是往下
            var events = event.touches[0] || event;
            // 移动距离
            var distanceY = events.pageY - that.data.posY;
            // 上下边缘检测
            if (distanceY > 0 && scrollTop == 0 && event.cancelable) {
                // 往上滑，并且到头
                // 禁止滚动的默认行为
                event.preventDefault();
                return;
            }
            // 下边缘检测
            if (distanceY < 0 &&
                scrollTop + 1 >= that.data.maxscroll &&
                event.cancelable) {
                // 往下滑，并且到头
                // 禁止滚动的默认行为
                event.preventDefault();
                return;
            }
        });
        tools_1.addHandler(that.container, 'touchend', function (event) {
            that.data.maxscroll = 0;
        });
        // 防止多次重复绑定
        that.container.setAttribute('isBindScroll', true);
    },
    preventScroll: function () {
        this.htmlDom.classList.add('noscrollRoot');
    },
    allowScroll: function () {
        this.htmlDom.classList.remove('noscrollRoot');
    },
    styleHtml: 
    // eslint-disable-next-line no-multi-str
    '.noscrollRoot,\
           .noscrollRoot body {\
                overflow: hidden;\
            }\
            .noscrollRoot body {\
                position: relative;\
            }',
};
exports.default = smartScroll;
